export { default as ExploreScalarButton } from './components/ExploreScalarButton.vue'
